module.exports = __webpack_public_path__ + "img/about_1.ba478ad5.svg";